"use client";

import { useEffect } from "react";

let activeLockCount = 0;
let restorePageScrollStyles: (() => void) | null = null;
let lockedScrollY = 0;

/**
 * Prevents the document from scrolling while an overlay is open. The lock is
 * reference counted so nested overlays cannot unlock the page prematurely.
 */
export function usePageScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    const html = document.documentElement;
    const body = document.body;

    if (activeLockCount === 0) {
      const previousHtmlOverflow = html.style.overflow;
      const previousBodyOverflow = body.style.overflow;
      const previousBodyPosition = body.style.position;
      const previousBodyTop = body.style.top;
      const previousBodyLeft = body.style.left;
      const previousBodyRight = body.style.right;
      const previousBodyWidth = body.style.width;
      const previousBodyPaddingRight = body.style.paddingRight;
      const scrollbarWidth = window.innerWidth - html.clientWidth;

      lockedScrollY = window.scrollY;

      restorePageScrollStyles = () => {
        html.style.overflow = previousHtmlOverflow;
        body.style.overflow = previousBodyOverflow;
        body.style.position = previousBodyPosition;
        body.style.top = previousBodyTop;
        body.style.left = previousBodyLeft;
        body.style.right = previousBodyRight;
        body.style.width = previousBodyWidth;
        body.style.paddingRight = previousBodyPaddingRight;
        window.scrollTo(0, lockedScrollY);
      };

      html.style.overflow = "hidden";
      body.style.overflow = "hidden";
      body.style.position = "fixed";
      body.style.top = `-${lockedScrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    activeLockCount += 1;

    return () => {
      activeLockCount = Math.max(0, activeLockCount - 1);
      if (activeLockCount === 0) {
        restorePageScrollStyles?.();
        restorePageScrollStyles = null;
      }
    };
  }, [locked]);
}
